import React from 'react';

const GooglePlaySecurityPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-indigo-100 py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Eliminación de Cuenta y Datos
          </h1>
          <p className="text-xl text-gray-700">
            Información sobre la eliminación de su cuenta en BlueCMR
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            
            <h2>Información de la Aplicación</h2>
            <p>
              Esta política se aplica a la aplicación móvil <strong>BlueCMR</strong>, desarrollada por <strong>BLUECMR S.L.U.</strong> y disponible en Google Play Store con el identificador <strong>com.bluecmr.app</strong>.
            </p>

            <h2>Cómo Solicitar la Eliminación de su Cuenta</h2>
            <p>
              Si desea eliminar su cuenta de BlueCMR y todos los datos asociados a ella, siga estos pasos:
            </p>

            <ol>
              <li>
                <strong>Envíe un correo electrónico</strong> a <a href="mailto:contact@bluecmr.com">contact@bluecmr.com</a>
              </li>
              <li>
                <strong>Asunto del correo:</strong> "Solicitud de eliminación de cuenta"
              </li>
              <li>
                <strong>Incluya en el mensaje:</strong>
                <ul>
                  <li>Su nombre completo</li>
                  <li>El correo electrónico asociado a su cuenta de BlueCMR</li>
                  <li>Confirmación expresa de que desea eliminar su cuenta y todos sus datos</li>
                </ul>
              </li>
              <li>
                <strong>Plazo de respuesta:</strong> Procesaremos su solicitud en un plazo máximo de 30 días naturales desde la recepción de su correo electrónico.
              </li>
            </ol>

            <h2>Datos que se Eliminan</h2>
            <p>
              Cuando solicite la eliminación de su cuenta, se eliminarán de forma permanente los siguientes datos:
            </p>
            <ul>
              <li><strong>Datos de perfil:</strong> nombre, apellidos, correo electrónico, teléfono y fotografía de perfil</li>
              <li><strong>Datos de autenticación:</strong> credenciales de acceso y tokens de sesión</li>
              <li><strong>Preferencias de usuario:</strong> configuración de idioma, notificaciones y otras preferencias personalizadas</li>
              <li><strong>Datos de uso:</strong> historial de actividad dentro de la aplicación (excepto lo indicado en el apartado siguiente)</li>
              <li><strong>Datos técnicos:</strong> identificadores de dispositivo, logs de sesión y datos de analítica asociados a su cuenta</li>
            </ul>

            <h2>Datos que se Conservan</h2>
            <p>
              Por obligaciones legales, fiscales y contractuales, algunos datos deben conservarse durante períodos específicos:
            </p>

            <h3>1. Documentos de Transporte Firmados</h3>
            <p>
              Los documentos de transporte (eCMR, Carta de Porte, Documentos de Control) que haya firmado o en los que haya participado se conservarán durante:
            </p>
            <ul>
              <li><strong>Mínimo 5 años:</strong> según la normativa fiscal española (Ley General Tributaria)</li>
              <li><strong>Hasta 10 años:</strong> en función del tipo de documento y la normativa sectorial aplicable (transporte de mercancías peligrosas, productos alimentarios, etc.)</li>
            </ul>
            <p>
              <strong>Motivo de conservación:</strong> Cumplimiento de obligaciones legales en materia fiscal, mercantil y de transporte. Estos documentos tienen valor probatorio y deben estar disponibles para inspecciones administrativas y judiciales.
            </p>

            <h3>2. Datos de Facturación</h3>
            <p>
              Si ha sido cliente de pago de BlueCMR, conservaremos:
            </p>
            <ul>
              <li>Datos de facturación (nombre, NIF/CIF, dirección fiscal)</li>
              <li>Facturas emitidas y registros contables</li>
            </ul>
            <p>
              <strong>Período de conservación:</strong> 5 años desde la emisión de la última factura, conforme a la normativa fiscal vigente.
            </p>

            <h3>3. Datos para Defensa Legal</h3>
            <p>
              En caso de existir reclamaciones, litigios o procedimientos administrativos o judiciales en curso, los datos necesarios para la defensa de nuestros intereses legítimos se conservarán hasta la resolución definitiva del procedimiento y el transcurso de los plazos de prescripción aplicables.
            </p>

            <h3>4. Datos Anonimizados</h3>
            <p>
              Podemos conservar datos estadísticos y agregados de forma completamente anonimizada (sin posibilidad de identificación personal) para análisis internos, mejora del servicio y cumplimiento de obligaciones de información a autoridades competentes.
            </p>

            <h2>Efectos de la Eliminación de la Cuenta</h2>
            <p>
              Una vez eliminada su cuenta:
            </p>
            <ul>
              <li>No podrá acceder a la aplicación BlueCMR con sus credenciales anteriores</li>
              <li>Perderá el acceso a todos los documentos y datos almacenados en su cuenta (excepto los conservados por obligación legal)</li>
              <li>No podrá recuperar su cuenta ni los datos eliminados</li>
              <li>Si desea volver a utilizar BlueCMR, deberá crear una nueva cuenta</li>
            </ul>

            <h2>Normativa Aplicable</h2>
            <p>
              Esta política de eliminación de datos se rige por:
            </p>
            <ul>
              <li><strong>Reglamento (UE) 2016/679 (RGPD):</strong> Reglamento General de Protección de Datos</li>
              <li><strong>Ley Orgánica 3/2018 (LOPDGDD):</strong> Ley de Protección de Datos y Garantía de los Derechos Digitales</li>
              <li><strong>Ley 58/2003:</strong> Ley General Tributaria (conservación de documentos fiscales)</li>
              <li><strong>Código de Comercio:</strong> obligaciones de conservación de documentación mercantil</li>
              <li><strong>Normativa sectorial de transporte:</strong> según el tipo de mercancía y operación</li>
            </ul>

            <h2>Contacto</h2>
            <p>
              Para cualquier consulta sobre esta política o sobre el tratamiento de sus datos personales, puede contactarnos en:
            </p>
            <ul>
              <li><strong>Email:</strong> <a href="mailto:contact@bluecmr.com">contact@bluecmr.com</a></li>
              <li><strong>Dirección postal:</strong> Calle Fueros de Leon 1, 24402, Ponferrada, León, España</li>
            </ul>

            <p>
              Para más información sobre cómo tratamos sus datos personales, consulte nuestra <a href="/privacidad">Política de Privacidad</a> completa.
            </p>

            <p><strong>Última actualización:</strong> Febrero 2026</p>

          </div>
        </div>
      </section>
    </div>
  );
};

export default GooglePlaySecurityPage;
